import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import { ChatFilterMode } from "../types/chatMessageTypes";
import { AsyncChatIndicator } from "./AsyncChatIndicator";
import { LiveChatIndicator } from "./LiveChatIndicator";

interface ChatModeIndicatorProps {
  filterMode: ChatFilterMode;
  children: ReactNode;
}

const BORDER_STYLES: Record<ChatFilterMode, string> = {
  [ChatFilterMode.LIVE]: "border-l-4 border-l-success",
  [ChatFilterMode.ASYNC]: "border-l-4 border-l-tertiary",
  [ChatFilterMode.COMBINED]: "border-l-4 border-l-success", // Combined uses Live input
};

const MODE_INDICATORS: Record<ChatFilterMode, ReactNode> = {
  [ChatFilterMode.LIVE]: <LiveChatIndicator />,
  [ChatFilterMode.ASYNC]: <AsyncChatIndicator />,
  [ChatFilterMode.COMBINED]: <LiveChatIndicator />, // Combined uses Live input
};

export const ChatModeIndicator = ({
  filterMode,
  children,
}: ChatModeIndicatorProps) => {
  return (
    <div className={cn("flex flex-col gap-2 pl-3", BORDER_STYLES[filterMode])}>
      {MODE_INDICATORS[filterMode]}
      {children}
    </div>
  );
};
